'use client';
import { memo } from 'react';
import { Box, useBoolean } from '@chakra-ui/react';

import CustomOverlayLink from 'shared/CustomOverlayLink';
import { useMobileDevice } from 'shared/hooks';
import NextImage from 'shared/NextImage';

const CertificateComponent = ({ link, img }) => {
  // Эта излишняя логика делалась чтобы отключить hover на мобильных устройствах
  const { isMobileDevice } = useMobileDevice();
  const [isHover, setIsHover] = useBoolean(false);

  return (
    <Box
      pos="relative"
      role="group"
      w={{ laptop: '164px', tablet: '109px', mobile: '69px' }}
      h={{ laptop: '150px', tablet: '100px', mobile: '64px' }}
      onMouseEnter={isMobileDevice ? undefined : setIsHover.on}
      onMouseLeave={isMobileDevice ? undefined : setIsHover.off}
      onClick={isMobileDevice ? setIsHover.toggle : undefined}
    >
      <CustomOverlayLink title="Посмотреть сертификат" link={`/certificates${link}`} isExternal />

      <NextImage
        src={img}
        alt="Иконка сертификата"
        w="full"
        h="full"
        opacity={isHover ? '1' : '.38'}
        transition="opacity .3s"
      />
    </Box>
  );
};

export const Certificate = memo(CertificateComponent);
